import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';

import { TeacherService } from '@app/teacher/services/teacher.service';

@Component({
    selector: 'app-stat-menu',
    templateUrl: './stat-menu.component.html',
    styleUrls: ['./stat-menu.component.scss']
})
export class StatMenuComponent implements OnInit, OnDestroy {
    common_image = '/assets/images/statistics/common_table_inactive.png';
    summary_image = '/assets/images/statistics/summary_data_inactive.png';
    individual_image = '/assets/images/statistics/individual_data_inactive.png';
    active_common_image = '/assets/images/statistics/common_table_active.png';
    active_summary_image = '/assets/images/statistics/summary_data_active.png';
    active_individual_image = '/assets/images/statistics/individual_data_active.png';
    active_url: string;

    private destroy$: Subject<boolean> = new Subject<boolean>();

    constructor(private router: Router, private route: ActivatedRoute, private teacherService: TeacherService) {}

    public ngOnInit(): void {
        this.route.url.pipe(takeUntil(this.destroy$)).subscribe(params => {
            this.active_url = params[0].path;
        });
    }

    public ngOnDestroy(): void {
        this.destroy$.next(true);
    }

    public onMouseOver(icon: string): void {
        switch (icon) {
            case 'common':
                if (this.active_url === 'commontable') {
                    this.active_common_image = '/assets/images/statistics/common_table_hover.png';
                } else {
                    this.common_image = '/assets/images/statistics/common_table_hover.png';
                }
                break;
            case 'summary':
                if (this.active_url === 'summary') {
                    this.active_summary_image = '/assets/images/statistics/summary_data_hover.png';
                } else {
                    this.summary_image = '/assets/images/statistics/summary_data_hover.png';
                }
                break;
            case 'individual':
                if (this.active_url === 'individual') {
                    this.active_individual_image = '/assets/images/statistics/individual_data_hover.png';
                } else {
                    this.individual_image = '/assets/images/statistics/individual_data_hover.png';
                }
                break;
        }
    }

    public onMouseLeave(icon: string): void {
        switch (icon) {
            case 'common':
                if (this.active_url === 'commontable') {
                    this.active_common_image = '/assets/images/statistics/common_table_active.png';
                } else {
                    this.common_image = '/assets/images/statistics/common_table_inactive.png';
                }
                break;
            case 'summary':
                if (this.active_url === 'summary') {
                    this.active_summary_image = '/assets/images/statistics/summary_data_active.png';
                } else {
                    this.summary_image = '/assets/images/statistics/summary_data_inactive.png';
                }
                break;
            case 'individual':
                if (this.active_url === 'individual') {
                    this.active_individual_image = '/assets/images/statistics/individual_data_active.png';
                } else {
                    this.individual_image = '/assets/images/statistics/individual_data_inactive.png';
                }
                break;
        }
    }

    public linkClicked(section: string): void {
        switch (section) {
            case 'common':
                this.router.navigate(['../commontable'], { relativeTo: this.route });
                break;
            case 'summary':
                this.router.navigate(['../summary'], { relativeTo: this.route });
                break;
            case 'individual':
                this.teacherService.clearPupil();
                this.router.navigate(['../individual'], { relativeTo: this.route });
                break;
        }
    }
}
